import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-profile",
  "use": "icon-profile-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-profile\"><path d=\"M4 14v-1c0-1.7 1.3-3 3-3h2c1.7 0 3 1.3 3 3v1h1v-1c0-2.2-1.8-4-4-4H7c-2.2 0-4 1.8-4 4v1zM8 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-1C6.3 2 5 3.3 5 5s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol